import { Injectable, signal, WritableSignal, computed } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment.development';
import { LoginServices } from 'src/app/auth/login/services/login.service';
import { Autorizaciones } from 'src/app/officials/autorizaciones/interfaces/autorizaciones-interface';
import { map, Observable } from 'rxjs';
import { CacheService } from 'src/app/shared/services/cache-service';
import { ProcesoDetectado } from '../interfaces/tipos';

const apiVucUrl = environment.apiVucUrl;

@Injectable({
    providedIn: 'root',
})
export class RegistroProfesionalesService {
    private apiUrl = apiVucUrl + `api/v1.0/registro-profesionales`;

    _autorizacionesPersona: WritableSignal<Autorizaciones[]> = signal([]);
    autorizacionesPersona = computed(() => this._autorizacionesPersona());
    tipoAutorizacion: WritableSignal<number[]> = signal([]); // esta variable obtiene el tipo de autorizacion 1=Titular, 2= Profesional
    constructor(
        private http: HttpClient,
        private loginServices: LoginServices,
        private cacheService: CacheService
    ) {}

    consultaAutorizaciones(uniqueIdUsuarioAutoriza: string, tipos: number[]) {
        let userSessionReq = {
            uniqueId: this.loginServices.session()?.perfil?.uniqueId,
            usuario: this.loginServices.session()?.perfil?.usuario,
            documento: this.loginServices.session()?.perfil?.documento,
            correo: this.loginServices.session()?.perfil?.correo,
        };
        let url =
            this.apiUrl + `/consulta/${uniqueIdUsuarioAutoriza}?tipos=${tipos}`;
        return this.http.post<Autorizaciones[]>(url, userSessionReq, {
            observe: 'response',
        });
    }

    consultaProceso(extranjero: string, numDocumento: string): Observable<ProcesoDetectado[]> {
        const token = this.loginServices.session()?.token;
        const url = `${this.apiUrl}/verificar?extranjero=${extranjero}&numDocumento=${numDocumento}`;
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

        return this.cacheService.memoize(
          url,
          this.http.get(url, { headers, responseType: 'text' }).pipe(
            map((responseText: string) => {
              const fixedJson = responseText
                .replace(/([{,])\s*(\w+)\s*=/g, '$1"$2":')  // convierte = a :
                .replace(/([a-zA-ZñÑáéíóúÁÉÍÓÚ]+)(?=\s*[}\]])/g, '"$1"'); // agrega comillas a valores al final

              try {
                return JSON.parse(fixedJson) as ProcesoDetectado[];
              } catch (e) {
                console.error('Error al parsear la respuesta del backend:', e);
                return [];
              }
            })
          )
        );
      }


    solicitudRegistroProfesional(payload: any): Observable<any> {
        const token = this.loginServices.session()?.token; // Obtener token desde el servicio
        const url = `${this.apiUrl}/solicitud`; // Endpoint para hacer la solicitud
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

        return this.http.post(url, payload, { headers });
      }



}
